import api, { handleAPIErrors } from 'shared/api'

const FETCH_REQUEST = 'statisticsResults/FETCH_REQUEST'
const FETCH_SUCCESS = 'statisticsResults/FETCH_SUCCESS'
const FETCH_FAILURE = 'statisticsResults/FETCH_FAILURE'

const initialState = {
  result: {
    mainChart: {},
    comparedChart: {}
  },
  loaded: false,
  loading: false,
  errors: []
}

export function fetchRequest(payload = {}) {
  return {
    type: FETCH_REQUEST,
  }
}

export function fetchSuccess(payload) {
  return {
    type: FETCH_SUCCESS,
    payload,
  }
}

export function fetchFailure(errors = []) {
  return {
    type: FETCH_FAILURE,
    errors,
  }
}

export function loadResults(options = {}) {
  return (dispatch, getState) => {
    const state = getState()
    dispatch(fetchRequest())

    return api(`api/v1/statistics/results`, options)
      .then(response => response.json().then(json => ({ json, response })))
      .then(({ json, response }) => {
        if (!response.ok) {
          return Promise.reject(json)
        }

        dispatch(fetchSuccess(json))
      })
      .catch((exception) => {
        handleAPIErrors(exception, (errors) => {
          dispatch(fetchFailure(errors))
        })
      })
  }
}

// Reducer
export default function reducer(state = initialState, action = {}) {
  const { payload, type, errors } = action

  switch (type) {
    case FETCH_REQUEST:
      return Object.assign({}, state, {
        loading: true
      })
    case FETCH_SUCCESS:
      return Object.assign({}, state, {
        loading: false,
        loaded: true,
        errors: [],
        result: payload
      })
    case FETCH_FAILURE:
      return {
        ...state,
        loading: false,
        loaded: true,
        result: {
          ...state.result,
          errors: errors
        }
      }
    default:
      return state
  }
}

